export const Toast = ({message, toastProps}) => {
   return <div>{message}</div>
}
